import React, { PureComponent } from "react";
import { connect } from "react-redux";
import RadioButtonListFilter from "../../components/filters/RadioButtonListFilter";
import { updateFilter } from "../../actions/filter";
import { withTranslation } from "react-i18next";
import { updateHasChangedFilter } from "../../actions/componentStatus/hasChangedFilters";

const elementId = "DataSpeedGen";

class DataSpeedGenFilterContainer extends PureComponent {
  render() {
    const { t, updateFilter } = this.props;

    try {
      const dataSpeedGens = this.dataSpeedGens();

      if (dataSpeedGens == null || dataSpeedGens.length === 1) {
        return null;
      } else {
        return (
          <RadioButtonListFilter
            onChange={updateFilter}
            title={t("dataSpeedGenTitle")}
            value={this.dataSpeedGen()}
            values={dataSpeedGens}
          />
        );
      }
    } catch (e) {
      return null;
    }
  }

  dataSpeedGen() {
    const { dataSpeedGen } = this.props;

    if (dataSpeedGen.length < 1) {
      const sortedDataSpeedGens = this.sortedDataSpeedGens();
      if (sortedDataSpeedGens.length > 0) {
        return this.sortedDataSpeedGens()[0].toString();
      } else {
        return null;
      }
    } else {
      return dataSpeedGen[0].toString();
    }
  }

  dataSpeedGens() {
    const { t } = this.props;

    let values = [];

    for (const gen of this.sortedDataSpeedGens()) {
      values.push([gen, <span>{t("dataSpeedGenText", { gen: gen })}</span>]);
    }

    return values;
  }

  sortedDataSpeedGens() {
    const { dataSpeedGens } = this.props;

    if (dataSpeedGens.length > 0) {
      return [...dataSpeedGens].sort();
    } else {
      return [];
    }
  }
}

function mapStateToProps(state) {
  return {
    dataSpeedGen: state.filter[state.offerType].dataSpeedGen,
    dataSpeedGens:
      state.portalData.entities.dataSpeedGens[`${state.offerType}Ids`],
    hasChangedFilter: state.componentStatus.hasChangedFilters[elementId],
    offerType: state.offerType
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateFilter: (offerType, dataSpeedGen) => {
      dispatch(
        updateFilter(offerType, {
          dataSpeedGen: dataSpeedGen
        })
      );
    },
    updateHasChangedFilter: () => {
      dispatch(updateHasChangedFilter(elementId));
    }
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const { updateFilter, updateHasChangedFilter } = dispatchProps;
  const { dataSpeedGens, offerType } = stateProps;

  const sortedDataSpeedGens = [...dataSpeedGens].sort();

  return {
    ...stateProps,
    updateFilter: e => {
      const value = parseInt(e.target.value, 10);
      let newDataSpeedGens;

      if (value === sortedDataSpeedGens[0]) {
        newDataSpeedGens = [];
      } else {
        const valueIndex = sortedDataSpeedGens.indexOf(value);
        newDataSpeedGens = [
          ...new Set(sortedDataSpeedGens.slice(valueIndex))
        ];
      }

      updateHasChangedFilter();
      updateFilter(offerType, newDataSpeedGens);
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(withTranslation(["filters"])(DataSpeedGenFilterContainer));
